function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#b7d6d6;}.cls-2{stroke:#b7d6d6;stroke-width:0.25px;}.cls-2,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-3,.cls-4{fill:none;stroke:#1d3541;}.cls-3{stroke-width:3px;}.cls-4{stroke-width:3.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "PICA"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "64.99 56.09 40.07 6.43 15.35 56.09 64.99 56.09"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M62.27,58.65H6L34,2.32ZM11.73,55.08H56.49L34,10.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M9.43,61.15a2.94,2.94,0,1,1-2.94-2.94A2.93,2.93,0,0,1,9.43,61.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M29.81,34.57a2.95,2.95,0,1,1-2.95-2.94A2.94,2.94,0,0,1,29.81,34.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M30.76,34.79c5,0,9.11,3.06,9.11,6.83s-4.08,6.83-9.11,6.83V59.66h25.8L32.19,11.09,8,59.66"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.55 67.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.adf2d85c.svg";
export { ForwardRef as ReactComponent };